export default __webpack_public_path__ + "static/featured-image-7cb6046d45a846990c1f95d67c5bce1f.jpg";